import Config from "@/const/Config";
import { SyuugyouKisokuService } from "@/service/SyuugyouKisokuService";
import { SyozokuWithKisokus } from "@/types/SyuugyouKisoku";
import { Ref, ref, computed } from "vue";

/*
 * 初期処理
 */
export function useSyuugyouKisokuInit() {
  const loading = ref(0)
  const isError = ref(false)
  const srv = new SyuugyouKisokuService()

  // 就業規則一覧で必要なオプション類を取得する
  const syuugyouKisokus: Ref<SyozokuWithKisokus[]> = ref([])
  const getKisokuOptionsBySyozoku = async () => {
    loading.value++
    const res = await srv.getKisokuOptionsBySyozoku()
    if (!res) {
      isError.value = true
      loading.value--
      return
    }
    syuugyouKisokus.value = res
    loading.value--
  }

  // 就業規則APIのURLを返す
  const getKisokuURL = (id: number) => {
    return Config.API_URL + '/syuugyou_kisoku/detail/' + id
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  });

  return {
    syuugyouKisokus,
    isLoading,
    isError,
    getKisokuOptionsBySyozoku,
    getKisokuURL,
  }
}
